module.exports = __webpack_public_path__ + "static/media/Hair_1_grey.7e6591c0.svg";